/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directive, ElementRef, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";

import { NzMentionTriggerDirective } from "ng-zorro-antd/mention";
import { UiMentionService } from "../services/mention.service";

@Directive({
  selector: "input[uiMentionTrigger], textarea[uiMentionTrigger]",
  exportAs: "uiMentionTrigger",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiMentionTriggerDirective),
      multi: true,
    },
  ],
})
export class UiMentionTriggerDirective extends NzMentionTriggerDirective {
  public constructor(public el: ElementRef, uiMentionService: UiMentionService) {
    super(el, uiMentionService);
  }
}
